import gql from "graphql-tag";

export default gql`
  mutation markListingAsSold(
    $id: Int!
    $sold: Boolean!
    $soldToUserId: Int
    $soldAt: Datetime
    $active: Boolean!
  ) {
    updateCarsForSaleById(
      input: {
        id: $id
        carsForSalePatch: {
          sold: $sold
          soldToUserId: $soldToUserId
          soldAt: $soldAt
          active: $active
        }
      }
    ) {
      clientMutationId
      carsForSale {
        id
        sold
        soldToUserId
        soldAt
        active
      }
    }
  }
`;
